import React, { useEffect, useState } from 'react'
import {useNavigate} from 'react-router-dom'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import 'datatables.net-buttons/js/dataTables.buttons.min.js';
import 'datatables.net-buttons/js/buttons.html5.min.js';
import 'datatables.net-buttons/js/buttons.print.min.js';
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css';
import jszip from 'jszip';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { API_URL } from '../../';

const ClosedTicketTable = ({jobsData , status}) => {
  
  const history = useNavigate();
  const [currentUser, setCurrentUser]= useState({})
  
      const handleDelete = async(id)=>{
        
        let headersList = {
          "Accept": "*/*",
          "Content-Type": "application/json"
         }
         let response = await fetch(`${API_URL}/api/jobs/${id}`, { 
           method: "DELETE",
           headers: headersList
         });
         let data = await response.json();
         if(data.message=="Job status delete successfully"){
            window.location.reload();
         }
      
       
      }
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'))
      setCurrentUser(user)
      const table = $('#dataTable').DataTable({
        data: jobsData,
        responsive:true,
        pageLength: 10,
        lengthChange:false,
         columns: [
            { data: 'subject', render: function (data, type, row) {
                return `
                  <button class="btn view-btn" data-id="${row.id}">${data}</button>`;
              }, },
            { data: 'status' },
           
        ]
            
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/view-ticket/${id}`); // Navigate to the edit page
        });
        // $('#dataTable tbody').on('click', '.view-btn', function () {
        //   const id = $(this).data('id');
        //   history(`/drivers-view/${id}`); // Navigate to the edit page
        // });
    
        // // Event listener for delete button
        // $('#dataTable tbody').on('click', '.delete-btn', function () {
        //   const id = $(this).data('id');
        //   handleDelete(id); // Call the delete function
        // });
        return () => {
            table.destroy(true);
        };
    }, [jobsData]);

    return (
        <div className=" basic-data-table">
        <div className="card-header">
          <div className="row">
            <h5 className="col-md-6 card-title mb-0" style={{textTransform:'capitalize'}}>{status} Tickets</h5>
        
          </div>
        </div>
        <div className="card-body">
          <table className="table bordered-table mb-0" id="dataTable">
            <thead>
              <tr>
                
                <th scope="col">Subject</th>
                <th scope="col">Status</th>
              </tr>
            </thead>
            <tbody>
              {/* DataTables will populate this tbody */}
            </tbody>
          </table>
        </div>
      </div>
    )
}

export default ClosedTicketTable